import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconAspectRatio219: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1.5-IconAspectRatio219"><Path d="M2.75 6C1.23122 6 0 7.23122 0 8.75V15.25C0 16.7688 1.23122 18 2.75 18H21.25C22.7688 18 24 16.7688 24 15.25V8.75C24 7.23122 22.7688 6 21.25 6H2.75Z" fill="currentColor"/></CentralIconBase>;
});

export default IconAspectRatio219;
